// Desktop breakpoint helper (matches CSS @media min-width: 769px)
function isDesktop() {
  return window.matchMedia('(min-width: 769px)').matches;
}


// Trust Badges (desktop only)
(function() {
  function applyBadges() {
    if (!isDesktop()) return false;

    var target = document.querySelector('.product-form__item--payment-button');
    if (!target) return false;
    if (document.querySelector('.trust-badges')) return true; // already injected

    var html = '<div class="trust-badges">'
      + '<div class="trust-badge">'
      +   '<img src="https://cdn.shopify.com/s/files/1/1452/9794/files/image_5.png?v=1776340641" alt="Star rating">'
      +   '<span>4.9 star rating based on over 15,000 Pathfinder Gear reviews</span>'
      + '</div>'
      + '<div class="trust-badge">'
      +   '<img src="https://cdn.shopify.com/s/files/1/1452/9794/files/wpf_bank-cards.png?v=1776340642" alt="Payment methods">'
      +   '<span>We accept Visa, Mastercard, Discover, AMEX and PayPal</span>'
      + '</div>'
    + '</div>'
    + '<div class="trust-rewards">'
      + '<img src="https://cdn.shopify.com/s/files/1/1452/9794/files/Vector.png?v=1776341019" alt="Rewards">'
      + '<span>Receive 850 points for buying this item.<br><span class="Avada-ButtonMediumLink" style="display: block; cursor: pointer;">Join us to receive</span></span>'
    + '</div>';

    target.insertAdjacentHTML('afterend', html);
    return true;
  }

  if (applyBadges()) return;

  var observer = new MutationObserver(function() {
    if (applyBadges()) observer.disconnect();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });

  window.addEventListener('resize', function() {
    if (isDesktop() && !document.querySelector('.trust-badges')) {
      applyBadges();
    }
  });
})();




// Frequently Bought Together (desktop only)
(function() {
  function applyChanges() {
    if (!isDesktop()) return false;

    var container = document.querySelector('.cbb-frequently-bought-recommendations-container');
    var selectorList = document.querySelector('.cbb-frequently-bought-selector-list');
    if (!container || !selectorList) return false;

    if (!document.querySelector('.cbb-fbt-wrapper')) {
      var appBlock = container.parentElement;
      var wrapper = document.createElement('div');
      wrapper.className = 'cbb-fbt-wrapper';
      appBlock.insertBefore(wrapper, container);
      wrapper.appendChild(container);
      wrapper.appendChild(selectorList);
    }

    document.querySelectorAll('.cbb-frequently-bought-selector-input').forEach(function(input) {
      if (!input.nextElementSibling || !input.nextElementSibling.classList.contains('cbb-custom-check')) {
        var label = document.createElement('label');
        label.className = 'cbb-custom-check';
        label.setAttribute('for', input.id);
        input.parentNode.insertBefore(label, input.nextSibling);
      }
    });

    return true;
  }

  if (applyChanges()) return;

  var observer = new MutationObserver(function() {
    if (applyChanges()) observer.disconnect();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });

  window.addEventListener('resize', function() {
    if (isDesktop() && !document.querySelector('.cbb-fbt-wrapper')) {
      applyChanges();
    }
  });
})();




// Judge.me badge: ensure "Customer reviews" (not just "reviews") — desktop only
(function() {
  var INTERVAL = 300;

  function updateBadge(el) {
    if (!el) return;
    var text = (el.textContent || '').trim();
    if (/\bcustomer\s+reviews?\b/i.test(text)) return;
    var newText = text.replace(/\breviews?\b/i, function(match) {
      return 'Customer ' + match;
    });
    if (newText !== text) el.textContent = newText;
  }

  setInterval(function() {
    if (!isDesktop()) return;
    var el = document.querySelector('span.jdgm-prev-badge__text');
    updateBadge(el);
  }, INTERVAL);
})();





// Cart Trust Badges Block (Desktop Only)
(function() {
  var DESKTOP_MIN_WIDTH = 768; // px — desktop breakpoint
  var MAX_DURATION = 30000; // stop polling after 30s
  var interval = null;
  var startTime = null;

  function isDesktop() {
    return window.innerWidth >= DESKTOP_MIN_WIDTH;
  }

  function injectBadges() {
    var targets = document.querySelectorAll('div#desktop-code .cart_block__content');
    if (!targets.length) return;

    targets.forEach(function(target, index) {
      if (target.nextElementSibling && target.nextElementSibling.classList.contains('sb-cart-trust-badges')) {
        return;
      }

      var i = index;
      var block = document.createElement('div');
      block.className = 'sb-cart-trust-badges';
      block.innerHTML = `
        <div class="sb-trust-row">
          <span class="sb-trust-icon"><svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none"><mask id="sb-mask-truck-${i}" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="21" height="21"><rect width="21" height="21" fill="#D9D9D9"/></mask><g mask="url(#sb-mask-truck-${i})"><path d="M1.53125 11.6594C1.28333 11.6594 1.07552 11.5755 0.907813 11.4078C0.740104 11.2401 0.65625 11.0323 0.65625 10.7844C0.65625 10.5365 0.740104 10.3286 0.907813 10.1609C1.07552 9.99323 1.28333 9.90938 1.53125 9.90938H4.59375C4.84167 9.90938 5.04948 9.99323 5.21719 10.1609C5.3849 10.3286 5.46875 10.5365 5.46875 10.7844C5.46875 11.0323 5.3849 11.2401 5.21719 11.4078C5.04948 11.5755 4.84167 11.6594 4.59375 11.6594H1.53125ZM4.26562 16.7344C3.75521 16.224 3.5 15.6042 3.5 14.875H2.40625C2.11458 14.875 1.88125 14.7656 1.70625 14.5469C1.53125 14.3281 1.48021 14.0802 1.55312 13.8031L1.75 12.9719H4.48438C5.09688 12.9719 5.61458 12.7604 6.0375 12.3375C6.46042 11.9146 6.67188 11.3969 6.67188 10.7844C6.67188 10.5948 6.65 10.4198 6.60625 10.2594C6.5625 10.099 6.50417 9.93854 6.43125 9.77813H7.2625C7.875 9.77813 8.39271 9.56667 8.81563 9.14375C9.23854 8.72083 9.45 8.20312 9.45 7.59063C9.45 6.97813 9.23854 6.46042 8.81563 6.0375C8.39271 5.61458 7.875 5.40312 7.2625 5.40312H3.9375L4.06875 4.87813C4.15625 4.46979 4.35677 4.13802 4.67031 3.88281C4.98385 3.6276 5.35208 3.5 5.775 3.5H14.6562C14.9479 3.5 15.1813 3.60938 15.3563 3.82812C15.5313 4.04688 15.5823 4.29479 15.5094 4.57187L14.9406 7H16.625C16.9021 7 17.1646 7.06198 17.4125 7.18594C17.6604 7.3099 17.8646 7.48125 18.025 7.7L19.6656 9.86562C19.826 10.0698 19.9281 10.2922 19.9719 10.5328C20.0156 10.7734 20.0156 11.0177 19.9719 11.2656L19.3813 14.175C19.3375 14.3792 19.2354 14.5469 19.075 14.6781C18.9146 14.8094 18.7323 14.875 18.5281 14.875H17.5C17.5 15.6042 17.2448 16.224 16.7344 16.7344C16.224 17.2448 15.6042 17.5 14.875 17.5C14.1458 17.5 13.526 17.2448 13.0156 16.7344C12.5052 16.224 12.25 15.6042 12.25 14.875H8.75C8.75 15.6042 8.49479 16.224 7.98438 16.7344C7.47396 17.2448 6.85417 17.5 6.125 17.5C5.39583 17.5 4.77604 17.2448 4.26562 16.7344ZM3.28125 8.46563C3.03333 8.46563 2.82552 8.38177 2.65781 8.21406C2.4901 8.04635 2.40625 7.83854 2.40625 7.59063C2.40625 7.34271 2.4901 7.1349 2.65781 6.96719C2.82552 6.79948 3.03333 6.71563 3.28125 6.71563H7.21875C7.46667 6.71563 7.67448 6.79948 7.84219 6.96719C8.0099 7.1349 8.09375 7.34271 8.09375 7.59063C8.09375 7.83854 8.0099 8.04635 7.84219 8.21406C7.67448 8.38177 7.46667 8.46563 7.21875 8.46563H3.28125ZM6.125 15.75C6.37292 15.75 6.58073 15.6661 6.74844 15.4984C6.91615 15.3307 7 15.1229 7 14.875C7 14.6271 6.91615 14.4193 6.74844 14.2516C6.58073 14.0839 6.37292 14 6.125 14C5.87708 14 5.66927 14.0839 5.50156 14.2516C5.33385 14.4193 5.25 14.6271 5.25 14.875C5.25 15.1229 5.33385 15.3307 5.50156 15.4984C5.66927 15.6661 5.87708 15.75 6.125 15.75ZM14.875 15.75C15.1229 15.75 15.3307 15.6661 15.4984 15.4984C15.6661 15.3307 15.75 15.1229 15.75 14.875C15.75 14.6271 15.6661 14.4193 15.4984 14.2516C15.3307 14.0839 15.1229 14 14.875 14C14.6271 14 14.4193 14.0839 14.2516 14.2516C14.0839 14.4193 14 14.6271 14 14.875C14 15.1229 14.0839 15.3307 14.2516 15.4984C14.4193 15.6661 14.6271 15.75 14.875 15.75ZM13.9344 11.375H18.1562L18.2437 10.9156L16.625 8.75H14.5469L13.9344 11.375Z" fill="#795D44"/></g></svg></span>
          <span class="sb-trust-text"><strong>Free Shipping:</strong> U.S. Orders $125+ excl. HI, AK</span>
        </div>
        <div class="sb-trust-row">
          <span class="sb-trust-icon"><svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none"><mask id="sb-mask-shield-${i}" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="21" height="21"><rect width="21" height="21" fill="#D9D9D9"/></mask><g mask="url(#sb-mask-shield-${i})"><path d="M7 9.53748C7 10.3541 7.40104 11.1344 8.20312 11.8781C9.00521 12.6219 9.67604 13.2416 10.2156 13.7375C10.3031 13.8104 10.4016 13.8469 10.5109 13.8469C10.6203 13.8469 10.7188 13.8104 10.8063 13.7375C11.3313 13.2562 11.9948 12.6328 12.7969 11.8672C13.599 11.1015 14 10.325 14 9.53748C14 9.01248 13.8104 8.56039 13.4313 8.18123C13.0521 7.80206 12.6 7.61248 12.075 7.61248C11.7688 7.61248 11.4734 7.67446 11.1891 7.79841C10.9047 7.92237 10.675 8.09373 10.5 8.31248C10.325 8.09373 10.099 7.92237 9.82188 7.79841C9.54479 7.67446 9.24583 7.61248 8.925 7.61248C8.4 7.61248 7.94792 7.80206 7.56875 8.18123C7.18958 8.56039 7 9.01248 7 9.53748ZM10.2156 19.1406C10.1281 19.126 10.0406 19.1041 9.95312 19.075C7.98438 18.4187 6.41667 17.2047 5.25 15.4328C4.08333 13.6609 3.5 11.7541 3.5 9.71248V5.5781C3.5 5.21352 3.60573 4.88539 3.81719 4.59373C4.02865 4.30206 4.30208 4.0906 4.6375 3.95935L9.8875 1.9906C10.0917 1.91768 10.2958 1.88123 10.5 1.88123C10.7042 1.88123 10.9083 1.91768 11.1125 1.9906L16.3625 3.95935C16.6979 4.0906 16.9714 4.30206 17.1828 4.59373C17.3943 4.88539 17.5 5.21352 17.5 5.5781V9.71248C17.5 11.7541 16.9167 13.6609 15.75 15.4328C14.5833 17.2047 13.0156 18.4187 11.0469 19.075C10.9594 19.1041 10.8719 19.126 10.7844 19.1406C10.6969 19.1552 10.6021 19.1625 10.5 19.1625C10.3979 19.1625 10.3031 19.1552 10.2156 19.1406Z" fill="#795D44"/></g></svg></span>
          <span class="sb-trust-text"><strong>Free Insurance:</strong> For Orders $25+ <span class="sb-info-icon"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><mask id="sb-mask-info1-${i}" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16"><rect width="16" height="16" fill="#D9D9D9"/></mask><g mask="url(#sb-mask-info1-${i})"><path d="M8.47504 11.1416C8.60282 11.0139 8.66671 10.8555 8.66671 10.6666V7.99998C8.66671 7.81109 8.60282 7.65276 8.47504 7.52498C8.34726 7.3972 8.18893 7.33331 8.00004 7.33331C7.81115 7.33331 7.65282 7.3972 7.52504 7.52498C7.39726 7.65276 7.33337 7.81109 7.33337 7.99998V10.6666C7.33337 10.8555 7.39726 11.0139 7.52504 11.1416C7.65282 11.2694 7.81115 11.3333 8.00004 11.3333C8.18893 11.3333 8.34726 11.2694 8.47504 11.1416ZM8.47504 5.80831C8.60282 5.68053 8.66671 5.5222 8.66671 5.33331C8.66671 5.14442 8.60282 4.98609 8.47504 4.85831C8.34726 4.73054 8.18893 4.66665 8.00004 4.66665C7.81115 4.66665 7.65282 4.73054 7.52504 4.85831C7.39726 4.98609 7.33337 5.14442 7.33337 5.33331C7.33337 5.5222 7.39726 5.68053 7.52504 5.80831C7.65282 5.93609 7.81115 5.99998 8.00004 5.99998C8.18893 5.99998 8.34726 5.93609 8.47504 5.80831ZM8.00004 14.6666C7.07782 14.6666 6.21115 14.4916 5.40004 14.1416C4.58893 13.7916 3.88337 13.3166 3.28337 12.7166C2.68337 12.1166 2.20837 11.4111 1.85837 10.6C1.50837 9.78887 1.33337 8.9222 1.33337 7.99998C1.33337 7.07776 1.50837 6.21109 1.85837 5.39998C2.20837 4.58887 2.68337 3.88331 3.28337 3.28331C3.88337 2.68331 4.58893 2.20831 5.40004 1.85831C6.21115 1.50831 7.07782 1.33331 8.00004 1.33331C8.92226 1.33331 9.78893 1.50831 10.6 1.85831C11.4112 2.20831 12.1167 2.68331 12.7167 3.28331C13.3167 3.88331 13.7917 4.58887 14.1417 5.39998C14.4917 6.21109 14.6667 7.07776 14.6667 7.99998C14.6667 8.9222 14.4917 9.78887 14.1417 10.6C13.7917 11.4111 13.3167 12.1166 12.7167 12.7166C12.1167 13.3166 11.4112 13.7916 10.6 14.1416C9.78893 14.4916 8.92226 14.6666 8.00004 14.6666Z" fill="#FF8300"/></g></svg></span></span>
        </div>
        <div class="sb-trust-row">
          <span class="sb-trust-icon"><svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none"><mask id="sb-mask-warranty-${i}" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="21" height="21"><rect width="21" height="21" fill="#D9D9D9"/></mask><g mask="url(#sb-mask-warranty-${i})"><path d="M19.25 11.8125V17.9375C19.25 18.3021 19.1224 18.612 18.8672 18.8672C18.612 19.1224 18.3021 19.25 17.9375 19.25H11.8125C11.4479 19.25 11.138 19.1224 10.8828 18.8672C10.6276 18.612 10.5 18.3021 10.5 17.9375V11.8125C10.5 11.4479 10.6276 11.138 10.8828 10.8828C11.138 10.6276 11.4479 10.5 11.8125 10.5H17.9375C18.3021 10.5 18.612 10.6276 18.8672 10.8828C19.1224 11.138 19.25 11.4479 19.25 11.8125ZM12.25 17.5H17.5V12.25L12.25 17.5ZM10.5 4.375C8.79375 4.375 7.34635 4.96927 6.15781 6.15781C4.96927 7.34635 4.375 8.79375 4.375 10.5C4.375 11.55 4.61198 12.5125 5.08594 13.3875C5.5599 14.2625 6.19792 14.9771 7 15.5312V14C7 13.7521 7.08385 13.5443 7.25156 13.3766C7.41927 13.2089 7.62708 13.125 7.875 13.125C8.12292 13.125 8.33073 13.2089 8.49844 13.3766C8.66615 13.5443 8.75 13.7521 8.75 14V17.5C8.75 17.7479 8.66615 17.9557 8.49844 18.1234C8.33073 18.2911 8.12292 18.375 7.875 18.375H4.375C4.12708 18.375 3.91927 18.2911 3.75156 18.1234C3.58385 17.9557 3.5 17.7479 3.5 17.5C3.5 17.2521 3.58385 17.0443 3.75156 16.8766C3.91927 16.7089 4.12708 16.625 4.375 16.625H5.55625C4.65208 15.8958 3.9375 15.0026 3.4125 13.9453C2.8875 12.888 2.625 11.7396 2.625 10.5C2.625 9.40625 2.83281 8.38177 3.24844 7.42656C3.66406 6.47135 4.22552 5.6401 4.93281 4.93281C5.6401 4.22552 6.47135 3.66406 7.42656 3.24844C8.38177 2.83281 9.40625 2.625 10.5 2.625C12.1625 2.625 13.65 3.08073 14.9625 3.99219C16.275 4.90365 17.2229 6.08854 17.8063 7.54688C17.8938 7.78021 17.8938 8.00625 17.8063 8.225C17.7188 8.44375 17.5583 8.59688 17.325 8.68438C17.0917 8.77188 16.862 8.77188 16.6359 8.68438C16.4099 8.59688 16.2531 8.43646 16.1656 8.20312C15.7135 7.06562 14.9807 6.14323 13.9672 5.43594C12.9536 4.72865 11.7979 4.375 10.5 4.375Z" fill="#795D44"/></g></svg></span>
          <span class="sb-trust-text"><strong>Warranty and Returns</strong> <span class="sb-info-icon"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><mask id="sb-mask-info2-${i}" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16"><rect width="16" height="16" fill="#D9D9D9"/></mask><g mask="url(#sb-mask-info2-${i})"><path d="M8.47504 11.1416C8.60282 11.0139 8.66671 10.8555 8.66671 10.6666V7.99998C8.66671 7.81109 8.60282 7.65276 8.47504 7.52498C8.34726 7.3972 8.18893 7.33331 8.00004 7.33331C7.81115 7.33331 7.65282 7.3972 7.52504 7.52498C7.39726 7.65276 7.33337 7.81109 7.33337 7.99998V10.6666C7.33337 10.8555 7.39726 11.0139 7.52504 11.1416C7.65282 11.2694 7.81115 11.3333 8.00004 11.3333C8.18893 11.3333 8.34726 11.2694 8.47504 11.1416ZM8.47504 5.80831C8.60282 5.68053 8.66671 5.5222 8.66671 5.33331C8.66671 5.14442 8.60282 4.98609 8.47504 4.85831C8.34726 4.73054 8.18893 4.66665 8.00004 4.66665C7.81115 4.66665 7.65282 4.73054 7.52504 4.85831C7.39726 4.98609 7.33337 5.14442 7.33337 5.33331C7.33337 5.5222 7.39726 5.68053 7.52504 5.80831C7.65282 5.93609 7.81115 5.99998 8.00004 5.99998C8.18893 5.99998 8.34726 5.93609 8.47504 5.80831ZM8.00004 14.6666C7.07782 14.6666 6.21115 14.4916 5.40004 14.1416C4.58893 13.7916 3.88337 13.3166 3.28337 12.7166C2.68337 12.1166 2.20837 11.4111 1.85837 10.6C1.50837 9.78887 1.33337 8.9222 1.33337 7.99998C1.33337 7.07776 1.50837 6.21109 1.85837 5.39998C2.20837 4.58887 2.68337 3.88331 3.28337 3.28331C3.88337 2.68331 4.58893 2.20831 5.40004 1.85831C6.21115 1.50831 7.07782 1.33331 8.00004 1.33331C8.92226 1.33331 9.78893 1.50831 10.6 1.85831C11.4112 2.20831 12.1167 2.68331 12.7167 3.28331C13.3167 3.88331 13.7917 4.58887 14.1417 5.39998C14.4917 6.21109 14.6667 7.07776 14.6667 7.99998C14.6667 8.9222 14.4917 9.78887 14.1417 10.6C13.7917 11.4111 13.3167 12.1166 12.7167 12.7166C12.1167 13.3166 11.4112 13.7916 10.6 14.1416C9.78893 14.4916 8.92226 14.6666 8.00004 14.6666Z" fill="#FF8300"/></g></svg></span></span>
        </div>
        <div class="sb-trust-row">
          <span class="sb-trust-icon"><svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none"><mask id="sb-mask-card-${i}" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="21" height="21"><rect width="21" height="21" fill="#D9D9D9"/></mask><g mask="url(#sb-mask-card-${i})"><path d="M16.625 16.625H14.875C14.6271 16.625 14.4193 16.5411 14.2516 16.3734C14.0839 16.2057 14 15.9979 14 15.75C14 15.5021 14.0839 15.2943 14.2516 15.1266C14.4193 14.9589 14.6271 14.875 14.875 14.875H16.625V13.125C16.625 12.8771 16.7089 12.6693 16.8766 12.5016C17.0443 12.3339 17.2521 12.25 17.5 12.25C17.7479 12.25 17.9557 12.3339 18.1234 12.5016C18.2911 12.6693 18.375 12.8771 18.375 13.125V14.875H20.125C20.3729 14.875 20.5807 14.9589 20.7484 15.1266C20.9161 15.2943 21 15.5021 21 15.75C21 15.9979 20.9161 16.2057 20.7484 16.3734C20.5807 16.5411 20.3729 16.625 20.125 16.625H18.375V18.375C18.375 18.6229 18.2911 18.8307 18.1234 18.9984C17.9557 19.1661 17.7479 19.25 17.5 19.25C17.2521 19.25 17.0443 19.1661 16.8766 18.9984C16.7089 18.8307 16.625 18.6229 16.625 18.375V16.625ZM3.5 10.5H17.5V7H3.5V10.5ZM3.5 17.5C3.01875 17.5 2.60677 17.3286 2.26406 16.9859C1.92135 16.6432 1.75 16.2312 1.75 15.75V5.25C1.75 4.76875 1.92135 4.35677 2.26406 4.01406C2.60677 3.67135 3.01875 3.5 3.5 3.5H17.5C17.9813 3.5 18.3932 3.67135 18.7359 4.01406C19.0786 4.35677 19.25 4.76875 19.25 5.25V9.625C19.25 9.87292 19.1661 10.0807 18.9984 10.2484C18.8307 10.4161 18.6229 10.5 18.375 10.5H16.625C15.4146 10.5 14.3828 10.9266 13.5297 11.7797C12.6766 12.6328 12.25 13.6646 12.25 14.875V16.625C12.25 16.8729 12.1661 17.0807 11.9984 17.2484C11.8307 17.4161 11.6229 17.5 11.375 17.5H3.5Z" fill="#795D44"/></g></svg></span>
          <span class="sb-trust-text">We accept <strong>Visa, Mastercard, Discover, AMEX</strong> and <strong>PayPal</strong></span>
        </div>
      `;

      target.insertAdjacentElement('afterend', block);
    });
  }

  function removeBadges() {
    document.querySelectorAll('.sb-cart-trust-badges').forEach(function(el) {
      el.remove();
    });
  }

  function startPolling() {
    if (interval) return;
    startTime = Date.now();
    interval = setInterval(function() {
      if (Date.now() - startTime > MAX_DURATION) {
        clearInterval(interval);
        interval = null;
        return;
      }
      if (!isDesktop()) return;
      injectBadges();
    }, 500);
  }

  function stopPolling() {
    if (interval) {
      clearInterval(interval);
      interval = null;
    }
  }

  if (isDesktop()) startPolling();

  var resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      if (isDesktop()) {
        startPolling();
        injectBadges();
      } else {
        stopPolling();
        removeBadges();
      }
    }, 150);
  });
})();




// Cart Trust Badges - Info Popups
(function() {
  var POPUP_CONTENT = {
    insurance: {
      title: 'Shipping Insurance',
      html: '<p>All orders where product total equals $25 or more are shipped insured. For more information about the insurance and claim process, please <a href="https://www.selfrelianceoutfitters.com/pages/shipping-insurance" class="sb-popup-link">click here</a>.</p>'
    },
    warranty: {
      title: 'Warranty and Returns',
      html: '<div class="custom-faq-body"><p><strong>Can I send it back for an exchange?</strong><br>No, but you can send it back for a store gift to use towards your next purchase. Include a copy of your receipt or email confirmation and indicate what you wish to get as a store gift card. Return shipping is at your expense.<br>Send to:<br>Self Reliance Outfitters<br>6050 Churchman Bypass<br>Indianapolis, IN 46203<br>Attn: New Return</p><p><strong>How will my refund be processed?</strong></p><p><strong>Domestic customers:</strong> Refunds (including canceled orders) will be processed by the original payment method or issued a store gift card if requested.</p><p><strong>International customers:</strong> Refunds (including canceled orders) will be processed by the original payment method or issued a store gift card if requested.<br>Refunds on returned merchandise will be processed within 7 business days upon receipt of the returned merchandise.</p><p><strong>Can I return an unwanted item?</strong><br>You may return any unused item (in its original packaging) within 30 days of purchase for a full refund. Drop ship items are not returnable. Return shipping is at your expense.<br>Send to:<br>Self Reliance Outfitters<br>6050 Churchman Bypass<br>Indianapolis, IN 46203<br>Attn: New Return</p><p><strong>What is the warranty on your products?</strong><br>Most products (except PKS Knives &amp; DIY Blanks) carry a 1-year warranty. View the Pathfinder Promise for our Pathfinder Stainless Steel gear - <a href="https://www.selfrelianceoutfitters.com/pages/returns-company-policies" target="_blank" rel="noopener">click here</a>.</p><p><strong>Does your PKS DIY Blanks have a lifetime warranty?</strong><br>No, since they are a DIY item and an unfinished knife, blanks come with a 6-month warranty.</p><p><strong>What is the warranty on PKS Knives?</strong><br>All PKS knives (except DIY blanks) come with a lifetime workmanship warranty.</p></div>'
    }
  };

  function ensurePopup() {
    var existing = document.querySelector('.sb-info-popup-overlay');
    if (existing) return existing;

    var overlay = document.createElement('div');
    overlay.className = 'sb-info-popup-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.innerHTML =
      '<div class="sb-info-popup">' +
        '<button class="sb-info-popup-close" aria-label="Close">&times;</button>' +
        '<h3 class="sb-info-popup-title"></h3>' +
        '<div class="sb-info-popup-content"></div>' +
      '</div>';

    document.body.appendChild(overlay);

    overlay.addEventListener('click', function(e) {
      if (e.target === overlay || e.target.classList.contains('sb-info-popup-close')) {
        closePopup();
      }
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closePopup();
    });

    return overlay;
  }

  function openPopup(type) {
    var data = POPUP_CONTENT[type];
    if (!data) return;
    var overlay = ensurePopup();
    overlay.querySelector('.sb-info-popup-title').textContent = data.title;
    overlay.querySelector('.sb-info-popup-content').innerHTML = data.html;
    overlay.classList.add('sb-active');
    document.body.classList.add('sb-popup-open');
  }

  function closePopup() {
    var overlay = document.querySelector('.sb-info-popup-overlay');
    if (!overlay) return;
    overlay.classList.remove('sb-active');
    document.body.classList.remove('sb-popup-open');
  }

  document.addEventListener('click', function(e) {
    var icon = e.target.closest && e.target.closest('.sb-info-icon');
    if (!icon) return;

    var row = icon.closest('.sb-trust-row');
    if (!row) return;

    e.preventDefault();
    e.stopPropagation();

    var text = row.textContent.toLowerCase();
    if (text.indexOf('insurance') !== -1) {
      openPopup('insurance');
    } else if (text.indexOf('warranty') !== -1) {
      openPopup('warranty');
    }
  });
})();